import styled, { css } from 'styled-components';
import { Modal } from 'reactstrap';
import { rem } from 'polished';
import { fontFamily } from '@whitelabel/helpers/style/type';
import { color } from '@whitelabel/helpers/style/colors';
import { borderRadius } from '@whitelabel/helpers/style/box';
import { mediaBreakpointDown, mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { Alert } from '@whitelabel/component-library';

export const StyledContactModal = styled(Modal)`
  font-family: ${fontFamily('base')};
  position: relative;
  height: 100%;
  width: 100%;
  min-height: 20rem;
  padding: 1rem;
  margin: 0 auto;
  .card {
    margin-bottom: 0;
  }
  .btn-close {
    color: ${color('white')};
    opacity: 1;
    width: 0.5rem;
    height: 0.5rem;
  }

  > .modal-content {
    border: 0;
    border-radius: ${borderRadius('base')};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 45rem;
    min-height: 20rem;
    ${mediaBreakpointDown('sm')`
      width: 21.563rem;
      max-width:100%;
    `}
  }
  .contact-form {
    max-height: 100vh;
    overflow: auto;
  }
`;

export const StyledLoadingCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${rem(533)};
`;

export const marginTop = css`
  margin-top: 1rem;

  ${mediaBreakpointUp('md')`
    margin-top: 1.5rem;
  `}
`;

export const StyledAlert = styled(Alert)`
  ${marginTop}
  margin-bottom: 0;
`;
